const words = ["Cultural Heritage", "Training Pathways", "First Aid & CPR", "Mental Health", "Safe Housing", "Safe Transport", "Food Hampers", "Art Therapy", "Counselling", "Seniors & Elders", "Youth Leadership", "Caring for Country", "Kamay · Gweagal Country"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-display text-5xl italic sm:text-7xl lg:text-8xl">{w}</span>
        <svg viewBox="0 0 20 20" className="h-5 w-5 text-ochre" aria-hidden="true"><circle cx="10" cy="10" r="6" fill="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = ({ className = "" }) => (
  <section data-testid="editorial-marquee" className={`overflow-hidden border-y border-ink/15 py-8 ${className}`} aria-label="Our focus areas">
    <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
      <Row />
      <Row />
    </div>
  </section>
);
